"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axiosConfig_1 = require("../config/axiosConfig");
const apiPaths_1 = require("../shared/constants/apiPaths");
const path_1 = require("../config/path");
/**
 * Axios instance configuration for the translations API.
 *
 * @param {string} paramComponent
 *   The translations API accepts filtering of messages by the component GET parameter.
 * @returns {{baseURL: string; params: {component: string}}}
 */
const translationApiConfig = (paramComponent, config) => {
    return {
        baseURL: path_1.buildCmsApiBaseUrl(config) + '/',
        params: {
            component: paramComponent,
            brand: config.multiDimensions.brand,
            country: config.multiDimensions.country,
            language: config.multiDimensions.language,
        },
        withCredentials: config.withCredentials || false
    };
};
const axios = axiosConfig_1.default;
exports.translationsApi = {
    translations: (paramComponent, config) => {
        return axios.get(apiPaths_1.TRANSLATIONS, translationApiConfig(paramComponent, config));
    }
};
//# sourceMappingURL=translationsApi.js.map